<template>
    <component :is="resolvedName"/>
</template>

<script>
export default {
    props: {
        name: String
    },

    computed: {
        resolvedName() {
            return `Icon${this.name}`;
        }
    }
};
</script>
